import { useRef } from "react";
import "./Hero.css";

const GCS_BASE_URL = "https://storage.googleapis.com/portfolio-media-circus";

// Trim the hero video by setting start and end times (in seconds)
const TRIM_START = 0;
const TRIM_END = 3;

//function Hero({ videoFileName = "ruigaard1.mp4" }) {
export function Hero({ videoFileName = "bunker-nbgb.mp4" }) {
  const videoRef = useRef(null);

  const handleLoadedMetadata = () => {
    if (videoRef.current) {
      videoRef.current.currentTime = TRIM_START;
    }
  };

  const handleTimeUpdate = () => {
    const video = videoRef.current;
    if (video && video.currentTime >= TRIM_END) {
      video.currentTime = TRIM_START;
    }
  };

  return (
    <section className="hero">
      <video
        ref={videoRef}
        className="hero-video"
        autoPlay
        muted
        playsInline
        onLoadedMetadata={handleLoadedMetadata}
        onTimeUpdate={handleTimeUpdate}
      >
        <source src={`${GCS_BASE_URL}/${videoFileName}`} type="video/mp4" />
      </video>
      <div className="hero-overlay" />
      <div className="hero-content">
        <h1 className="hero-title">Carlos Mario Lopez</h1>
        <p className="hero-subtitle">Circus Artist</p>
      </div>
      <div className="hero-scroll-indicator">
        <span className="hero-chevron" />
      </div>
    </section>
  );
}

export function HeroLoop({ videoFileName = "ruigaard1.mp4" }) {
  return (
    <section className="hero">
      <video className="hero-video" autoPlay muted loop playsInline>
        <source src={`${GCS_BASE_URL}/${videoFileName}`} type="video/mp4" />
      </video>
      <div className="hero-overlay" />
      <div className="hero-content">
        <h1 className="hero-title">Carlos Mario Lopez</h1>
        <p className="hero-subtitle">Circus Artist</p>
      </div>
      <div className="hero-scroll-indicator">
        <span className="hero-chevron" />
      </div>
    </section>
  );
}
